import { render, staticRenderFns } from "./contractDetailChange.vue?vue&type=template&id=cdda8734&scoped=true"
import script from "./contractDetailChange.vue?vue&type=script&lang=js"
export * from "./contractDetailChange.vue?vue&type=script&lang=js"
import style0 from "./contractDetailChange.vue?vue&type=style&index=0&id=cdda8734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdda8734",
  null
  
)

export default component.exports